exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".equipment-labels .search-form[data-v-9891bd74] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n.equipment-labels .search-form .title[data-v-9891bd74] {\n  font-size: 18px;\n  font-weight: 400;\n  color: #252525;\n  margin-right: 56px;\n}\n.equipment-labels .search-form .title[data-v-9891bd74]  .el-form-item__content {\n  font-size: 18px;\n}\n.equipment-labels .search-form[data-v-9891bd74]  .el-form-item {\n  margin-right: 32px;\n}", ""]);

// exports
